import { useDeviceType } from '@cian/ui-kit';
import { Accordion } from 'shared/components/Accordion';
import { TPoints } from 'shared/types/points';
import { AccordionItemContainer } from '../AccordionItemContainer';

interface IAccordionContainerProps {
  items: TPoints[];
}

export const AccordionContainer: React.FC<IAccordionContainerProps> = ({ items }) => {
  const device = useDeviceType();

  return <Accordion items={items} device={device} Item={AccordionItemContainer} />;
};
